module.exports = __webpack_public_path__ + "static/img/6.85d2333.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/6.png
// module id = SF9o
// module chunks = 0